import React, { createContext, useContext, useState, useCallback, ReactNode, useMemo } from 'react';
import { messages } from '../config/config';

interface ConfigState {
  errorMessage: string;
  title: string;
  message: string;
  enableLogin: boolean;
  enableForgot: boolean;
  key: string;
  token: string;
}
interface ConfigContextType {
  config: ConfigState;
  updateConfig: (newConfig: Partial<ConfigState>) => void;
}

const page = globalThis.location.pathname.includes('forgot') ? 'forgotPassword':'login'

const initialState:ConfigState = {
  errorMessage: "",
  title: messages[page].default.title,
  message: messages[page].default.message,
  enableLogin: false,
  enableForgot: false,
  key: "",
  token: ""
}

interface ConfigProviderProps {
  children: ReactNode; // Tipar children como ReactNode
}

const ConfigContext = createContext<ConfigContextType>({config:initialState,updateConfig:()=>{}});

export const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {

  const [config, setConfig] = useState<ConfigState>(initialState);
  const updateConfig = useCallback((newConfig:Partial<ConfigState>) => {
    setConfig((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);

  const contextValue = useMemo(() => ({
    config,
    updateConfig,
  }), [config, updateConfig]);
  
  return (
    <ConfigContext.Provider value={contextValue}>
      {children}
    </ConfigContext.Provider>
  )

};

export const useConfig = () => {
  return useContext(ConfigContext);
};